import { useEffect, useRef } from 'react';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ToastProvider } from './components/ui/ToastProvider';
import { AppRoutes } from './routes';
import { useTokenRefresh } from './lib/hooks/useTokenRefresh';
import { useAuthStore } from './stores/authStore';

function App() {
  useTokenRefresh();

  const { isAuthenticated, loadProfile, setUserFromToken } = useAuthStore();
  const profileRequestedRef = useRef(false);

  // Có token thì điền user từ JWT (nếu chưa có) rồi gọi profile khi chưa có user đầy đủ.
  useEffect(() => {
    if (!isAuthenticated) {
      profileRequestedRef.current = false;
      return;
    }
    if (profileRequestedRef.current) return;
    profileRequestedRef.current = true;
    setUserFromToken();
    loadProfile();
  }, [isAuthenticated, loadProfile, setUserFromToken]);

  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-background">
        <AppRoutes />
      </div>
      <ToastProvider />
    </ErrorBoundary>
  );
}

export default App;
